import { Box, Spacer, Stack, Text, VStack } from "@chakra-ui/react";
import dayjs from "dayjs";
import StarDisplay from "./StarDisplay";

export const ReviewCard = ({ review, lastReview }) => {
  const { id, author_name, text, rating, time, profile_photo_url } = review;

  return (
    <>
      <Box key={id} mt={10} mb={10}>
        <Stack
          direction={["row", "row"]}
          alignItems={["center", "flex-start"]}
          mb={4}
        >
          <img
            src={profile_photo_url}
            alt='profile'
            style={{
              width: "50px",
              height: "50px",
              marginRight: "4px",
            }}
          />
          <Stack
            direction={["column", "row"]}
            alignItems={"flex-start"}
            width='100%'
          >
            <VStack alignItems={"flex-start"} spacing={0}>
              <Text color={"gray.500"} m={0} fontWeight='bold'>
                {author_name}
              </Text>
              <Text color={"gray.400"}>
                {dayjs.unix(time).format("MMMM D, YYYY")}
              </Text>
            </VStack>
            <Spacer />
            <StarDisplay stars={rating} />
          </Stack>
        </Stack>

        {text ? (
          <Text mt={8}>{text}</Text>
        ) : (
          <Text as='i'>No review text provided</Text>
        )}
      </Box>
      {!lastReview && <Box h={0.5} bg={"gray.100"} />}
    </>
  );
};
